(function() {
    
    function funcReady() {
        $('.KRC1500').buildCommonUI();

        var KRC1500 = $('.component.KRC1500')
        var videoCapBtn = KRC1500.find('.video-caption-wrap .btn-video');
        var videoCapCloseBtn = KRC1500.find('.video-cap-section .btn-close');
        
        // 동영상 설명 보기
        videoCapBtn.on('click', function(){
            var videoCapOpenBtnLabel = $(this).attr('data-open');
            var videoCapCloseBtnLabel = $(this).attr('data-close');

            if( $(this).hasClass('on') ){
                $(this).removeClass('on');
                $(this).parents('.visual-area').find('.video-cap-section').hide();
                if( $(this).parents('.youtube-box').length || $(this).parents('.embed-box').length ) {
                    $(this).text(videoCapOpenBtnLabel);
                }   
            }else{
                $(this).addClass('on');
                $(this).parents('.visual-area').find('.video-cap-section').show();
                $(this).parents('.visual-area').find('.video-cap-section').focus();
                if( $(this).parents('.youtube-box').length || $(this).parents('.embed-box').length ) {
                    $(this).text(videoCapCloseBtnLabel);
                }
            }
        })

        // 동영상 설명 닫기
        videoCapCloseBtn.on('click', function(){
            $(this).parents('.visual-area').find('.video-cap-section').hide();
            $(this).parents('.visual-area').find('.video-caption-wrap .btn-video').removeClass('on');
            $(this).parents('.visual-area').find('.video-caption-wrap .btn-video').focus();
        })
    }

    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC1500', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC1500')) return false;
                $('.KRC1500').buildCommonUI();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC1500')) return false;

        funcReady();
    });
})();

